module.exports = __webpack_public_path__ + "static/media/loanService.32a5da3c.bin";